import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgStreamIcon = (
  { title, titleId, strokeWidth = 2, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <circle cx={12} cy={12} r={2} fill="currentColor" />
    <path
      d="M5.07 18.93a10 10 0 0 1 0-14.14"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      fill="none"
      strokeLinecap="round"
    />
    <path
      d="M18.93 18.93a10 10 0 0 0 0-14.14"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      fill="none"
      strokeLinecap="round"
    />
    <path
      d="M7.88 16.12a6 6 0 0 1 0-8.48"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      fill="none"
      strokeLinecap="round"
    />
    <path
      d="M16.12 16.12a6 6 0 0 0 0-8.48"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      fill="none"
      strokeLinecap="round"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgStreamIcon);
export default ForwardRef;
